export const BACKEND_API = "https://api1.pankritjindal.com";
// export const BACKEND_API = "http://52.64.82.221:6969";
// export const BACKEND_API = "http://127.0.0.1:6969";